import { ListLaborerCVFailResponse, ListLaborerCVResponse } from 'api/contractAuthAPI'
import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {
  errorMessage: string
  id: number
} & Status

const initialState: State = {
  errorMessage: '',
  id: 0,
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.LIST_LABORER_CV_ASYNC,
    Actions.LIST_LABORER_CV_SUCCESS,
    Actions.LIST_LABORER_CV_FAIL,
    ListLaborerCVResponse,
    ListLaborerCVFailResponse
  >,
) => {
  switch (action.type) {
    case Actions.LIST_LABORER_CV_ASYNC:
      return {
        ...state,
        ...action.status,
      }

    case Actions.LIST_LABORER_CV_SUCCESS:
      return {
        ...state,
        ...action.status,
        id: action.payload.data.id,
      }

    case Actions.LIST_LABORER_CV_FAIL:
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.message ?? '',
      }
    default:
      return state
  }
}
